<template>
    <div>
        <g-table-sync
            :app="app"
            :view="view"
            :columns="columns"
            :default-limit="10000"
            :required-filters="routeFilter"
            hideDelete
            hideSearch
            class="client-report-table"
        >
            <template v-slot:head-right="{ data }">
                <small> <strong> Importe Total: </strong> </small>
                <strong>{{ formatCurrency(getTotal(data)) }} </strong>
            </template>
            <template slot="total" slot-scope="{ item }">
                <span v-if="item.total"> {{ formatCurrency(item.total) }}</span>
            </template>
            <template slot="date" slot-scope="{ item }">
                <span>{{ item.date }}</span>
            </template>
            <template slot="status" slot-scope="{ item }">
                <g-select
                    :item="item._EntityId"
                    :app="app"
                    name="status"
                    :colors="[$colors.blue, $colors.orange, $colors.success, '#ff0000']"
                    block
                />
            </template>
        </g-table-sync>
    </div>
</template>

<script>
import billsMX from '../bills/mixins/bill.js'
import moment from 'moment'

export default {
    name: 'ClientTable',
    props: {
        client: {
            type: String,
            required: true,
        },
        date: {
            type: Array,
            required: true,
        },
    },
    mixins: [billsMX],
    data() {
        return {
            app: 'bills',
            view: 'clientBillsList',
            columns: [
                {
                    title: 'Nº',
                    index: 'serie',
                    order: true,
                    search: true,
                },
                {
                    title: 'Importe',
                    index: 'total',
                    order: true,
                    slot: 'total',
                },
                {
                    title: 'Estado',
                    index: 'status',
                    slot: 'status',
                    order: true,
                },
                {
                    title: 'eFactura',
                    index: 'efactura_date',
                    order: true,
                    slot: '_date',
                    search: false,
                    date: true,
                },
            ],
        }
    },
    computed: {
        routeFilter() {
            const date_from = this.date[0].format('YYYY-MM-DD')
            const date_to = this.date[1].format('YYYY-MM-DD')
            // const date_to = moment(this.date).endOf('month').format('YYYY-MM-DD')
            return [
                {
                    _ParentOperator: 'AND',
                    _Operator: 'AND',
                    Fields: {
                        client: {
                            type: 'number',
                            int: Number(this.client),
                            opt: '=',
                        },
                        date: {
                            type: 'date',
                            from: date_from,
                            to: date_to,
                        },
                    },
                },
            ]
        },
    },
    methods: {
        formatCurrency(value, fractions = 2) {
            const fixedValue = Number(value).toFixed(fractions)
            const formatter = new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: fractions,
                maximumFractionDigits: fractions,
            })
            return formatter.format(fixedValue)
        },
        getTotal(data) {
            if (!data.results.length) {
                return 0
            }
            return data.results.reduce((acc, cvv) => acc + cvv.total, 0)
        },
    },
}
</script>

<style lang="scss" >
.client-report-table {
    .card-body {
        .table-responsive {
            table {
                position: relative;
                display: flex;
                flex-direction: column;
                thead {
                    display: flex;
                    flex-direction: column;
                    position: sticky;
                    top: 0;
                    z-index: 1;
                    background: $white;
                }
                tbody {
                    display: flex;
                    flex-direction: column;
                    max-height: 18rem;
                    height: 100%;
                }
                tr{
                    display: grid;
                    grid-template-columns: auto repeat(4, 1fr);
                }
            }
        }
    }
}
</style>
